import { render, staticRenderFns } from "./TargetsChecks.vue?vue&type=template&id=959de9c6&"
import script from "./TargetsChecks.vue?vue&type=script&lang=js&"
export * from "./TargetsChecks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports